import { Link, useNavigate } from "react-router-dom";
import { AddToCartity, ViewDetails } from "../../../../Constant";
import { ModalButtonsProp, ProductItemInterface } from "../../../../Type/EcommerceType";
import { useAppDispatch } from "../../../../Redux-Toolkit/Hooks";
import { addToCartData } from "../../../../Redux-Toolkit/Reducers/CartSlice";

export const ModalButtons = ({ singleProduct, quantity }: ModalButtonsProp) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const AddToCarts = (item: ProductItemInterface) => {
    dispatch(addToCartData({ item, quantity }));
    navigate(`${process.env.PUBLIC_URL}/ECommerce/Cart`);
  };
    
  return (
    <div className="addcart-btn">
      <Link to={`${process.env.PUBLIC_URL}/ecommerce/cart`} className="btn btn-primary text-white me-3" onClick={() => AddToCarts(singleProduct)}>
        {AddToCartity}
      </Link>
      <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page/${singleProduct.id}`} className="btn btn-primary text-white">
        {ViewDetails}
      </Link>
    </div>
  );
};
